import { addItemToCollection } from "directus/src/operations";

// Add createCompany function
export async function createCompany({ item }) {
  try {
    const data = await addItemToCollection("companies", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
